import { Outlet, createFileRoute } from "@tanstack/react-router"
import { getNewProjectLayout } from "@/features/project-editor/server/projectServer"

// This file now defines the layout route for the new project steps
// Each child route provides its own EditorHeader for a unified experience
export const Route = createFileRoute("/(authenticated)/projects/new")({
  component: ProjectNewLayout,
  loader: async () => {
    // For the /projects/new route, we don't have a projectId yet
    return getNewProjectLayout({ data: {} }) as Promise<{ project: undefined }>
  },
})

function ProjectNewLayout() {
  // Simple layout container - each child page handles its own overflow/containment
  return (
    <div className="flex h-[calc(100vh-theme(space.16))] flex-col">
      <Outlet />
    </div>
  )
}
